export const filterObjectValuesByKeys = (
  object: Record<string, any> = {},
  keys: Record<string, any> = {}
): any[] =>
  Object.keys(object)
    .filter((key) => keys && keys.hasOwnProperty(key))
    .map((key) => object[key])?.[0]
